import styled from 'styled-components/macro';

export const TimePeriodsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
